import { CSSProperties } from 'react';
import { Loader } from '../Loader/Loader';

// Under a sticky header the page is a flex column; growing fills the space left and centres the
// spinner there. Outside a flex parent the rule is ignored and the full height does the same job.
const fillStyle: CSSProperties = { flex: 1 };

export function GenericLoadingFallback() {
  return <Loader height={'100%'} style={fillStyle} />;
}
